import {

    messaging,

    getToken,

    deleteToken,

    onMessage

} from "../firebase";


// ======================================================
// VAPID KEY
// ======================================================

const PUBLIC_VAPID_KEY =
    "BDYpVacvhLdwJA_Omu7dUNAJQo2zPKGzTtMIol_ByWdHlR0yapAJRCTmwyNf_NaQDEKSqWEspBE7TZD42yh1SFM";


// ======================================================
// FOREGROUND NOTIFICATION LISTENER
// ======================================================

// export const initializeFCM = () => {

//     onMessage(

//         messaging,

//         (payload) => {

//             console.log(
//                 "FOREGROUND MESSAGE:",
//                 payload
//             );

//             if (
//                 Notification.permission ===
//                 "granted"
//             ) {

//                 new Notification(

//                     payload.notification.title,

//                     {
//                         body:
//                             payload.notification.body,

//                         icon:
//                             "/logo192.png"
//                     }
//                 );
//             }
//         }
//     );
// };


// ======================================================
// GET NEW FCM TOKEN
// ======================================================

export const getFCMToken = async () => {

    try {

        const permission =
            await Notification
                .requestPermission();

        if (
            permission !== "granted"
        ) {

            console.log(
                "Notification permission denied"
            );

            return null;
        }

        const token =
            await getToken(

                messaging,

                {
                    vapidKey:
                        PUBLIC_VAPID_KEY
                }
            );

        console.log(
            "FCM TOKEN:",
            token
        );

        return token;

    } catch (e) {

        console.log(
            "GET TOKEN ERROR:",
            e
        );

        return null;
    }
};


// ======================================================
// SUBSCRIBE USER
// ======================================================

export const subscribeUser = async (
    baseURL,
    userId
) => {

    try {

        const token = await getFCMToken();

        if (!token) {

            return false;
        }

        // SAVE LOCAL STATE

        localStorage.setItem(
            "fcm_token",
            token
        );

        // SAVE TO BACKEND

        const response =
            await fetch(

                baseURL +
                "save-subscription/",

                {
                    method: "POST",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body: JSON.stringify({

                        token,

                        userId
                    })
                }
            );

        const data =
            await response.json();

        console.log(
            "SUBSCRIBE RESPONSE:",
            data
        );

        return true;

    } catch (e) {

        console.log(
            "SUBSCRIBE ERROR:",
            e
        );

        return false;
    }
};


// ======================================================
// UNSUBSCRIBE USER
// ======================================================

export const unsubscribeUser = async (
    baseURL
) => {

    try {

        const token =
            localStorage.getItem(
                "fcm_token"
            );

        if (!token) {

            console.log(
                "No token found"
            );

            return false;
        }

        // DELETE FIREBASE TOKEN

        await deleteToken(
            messaging
        );

        // REMOVE FROM BACKEND

        await fetch(

            baseURL +
            "remove-subscription/",

            {
                method: "POST",

                headers: {
                    "Content-Type":
                        "application/json"
                },

                body: JSON.stringify({
                    token
                })
            }
        );

        // REMOVE LOCAL STATE

        localStorage.removeItem(
            "fcm_token"
        );

        console.log(
            "FCM unsubscribed"
        );

        return true;

    } catch (e) {

        console.log(
            "UNSUBSCRIBE ERROR:",
            e
        );

        return false;
    }
};


// ======================================================
// CHECK SUBSCRIPTION
// ======================================================

export const checkSubscription = () => {

    const token =
        localStorage.getItem(
            "fcm_token"
        );

    console.log(
        "LOCAL TOKEN:",
        token
    );

    return !!token;
};


// ======================================================
// SEND TEST NOTIFICATION
// ======================================================

export const sendNotification =
    async (
        baseURL,
        message
    ) => {

        try {

            const response =
                await fetch(

                    baseURL +
                    "send-notification/",

                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body: JSON.stringify({

                            title:
                                "Task Notification",

                            message
                        })
                    }
                );

            const data =
                await response.json();

            console.log(
                "SEND RESPONSE:",
                data
            );

            return true;

        } catch (e) {

            console.log(
                "SEND ERROR:",
                e
            );

            return false;
        }
    };